import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import MUIDataTable from 'mui-datatables';
import TableCell from '@material-ui/core/TableCell';
import SearchIcon from '@material-ui/icons/Search';
import ShareIcon from '@material-ui/icons/Share';
import { gql, useQuery } from '@apollo/client';

import LockIcon from '../icons/LockIcon.jsx';
import LockOpenIcon from '../icons/LockOpenIcon.jsx';
import LockAlertIcon from '../icons/LockAlertIcon.jsx';
import LockClockIcon from '../icons/LockClockIcon.jsx';
import TableConfigurationIcon from '../icons/TableConfigurationIcon.jsx';

const useStyles = makeStyles(() => ({
  dataTable: {
    width: '100%',
    '& th': {
      padding: '0px',
    },
    '& td': {
      padding: '0px',
    },
  },
  headerIcon: {
    position: 'relative',
    right: '-90px',
  },
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '100%',
    minHeight: '600px',
  },
  dataTableActions: {
    '& span': {
      paddingLeft: '0px',
      paddingRight: '7px',
      '& svg': {
        verticalAlign: 'bottom',
      },
    },
  },
}));

const FETCH_DOORS = gql`
  query doors {
    doors {
      totalCount
      edges {
        acrId
        name
        doorType
        doorSubType
      }
    }
  }
`;

const DoorControlView = () => {
  const classes = useStyles();

  const queryError = ({ graphQLErrors, networkError }) => {};

  const [mrdDoors, setMrdDoors] = useState([]);

  const queryMrdDoorsCompleted = (data) => {
    setMrdDoors(data.doors.edges);
  };

  const { loading: loadingMrdDoors, ERROR: errorMrdDoors } = useQuery(FETCH_DOORS, {
    notifyOnNetworkStatusChange: true,
    onCompleted: queryMrdDoorsCompleted,
    onError: queryError,
    fetchPolicy: 'no-cache',
  });

  /* const columns = ['Door', 'State', 'Actions', 'Controller', 'Tags', 'Reporting']; */
  const columns = [
    {
      name: 'door',
      label: 'Door',
      options: {
        filter: true,
      },
    },
    {
      name: 'state',
      label: 'State',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'actions',
      label: 'Actions',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'controller',
      label: 'Controller',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'tags',
      label: 'Tags',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'reporting',
      label: 'Reporting',
      options: {
        customHeadRender: ({ index, ...column }) => {
          return (
            <TableCell key={index}>
              {column.label}
              <span className={classes.headerIcon}>
                <IconButton>
                  <ShareIcon />
                </IconButton>
                <IconButton>
                  <SearchIcon />
                </IconButton>
                <IconButton>
                  <TableConfigurationIcon />
                </IconButton>
              </span>
            </TableCell>
          );
        },
      },
    },
  ];

  const tableOptions = {
    filter: false,
    print: false,
    search: false,
    download: false,
    viewColumns: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    showFirstButton: true,
    showLastButton: true,
    selectableRowsOnClick: true,
  };

  const formattedControlData = () => {
    return mrdDoors.map((item) => {
      let actions;
      if (item.doorType === 'engage') {
        if (item.doorSubType === 'nde' || item.doorSubType === 'le') {
          actions = (
            <div className={classes.dataTableActions}>
              <span>
                <LockIcon className={classes.iconSize} style={{ color: '#616161' }} />
              </span>
              <span>
                <LockOpenIcon className={classes.iconSize} style={{ color: '#388e3c' }} />
              </span>
              <span>
                <LockClockIcon className={classes.iconSize} color="secondary" />
              </span>
            </div>
          );
        } else {
          actions = (
            <div className={classes.dataTableActions}>
              <span>
                <LockClockIcon className={classes.iconSize} color="secondary" />
              </span>
            </div>
          );
        }
      } else {
        actions = (
          <div className={classes.dataTableActions}>
            <span>
              <LockIcon className={classes.iconSize} style={{ color: '#616161' }} />
            </span>
            <span>
              <LockOpenIcon className={classes.iconSize} style={{ color: '#388e3c' }} />
            </span>
            <span>
              <LockAlertIcon className={classes.iconSize} style={{ color: '#f9a825 ' }} />
            </span>
            <span>
              <LockClockIcon className={classes.iconSize} color="secondary" />
            </span>
          </div>
        );
      }

      const doorState = [];

      const doorName = (
        <Typography color={item.state === 'Open' ? 'error' : 'initial'}>{item.name}</Typography>
      );
      return [doorName, doorState, actions];
    });
  };

  const renderedDoorControls = mrdDoors.length ? (
    <MUIDataTable
      data={formattedControlData()}
      columns={columns}
      options={tableOptions}
      className={classes.dataTable}
    />
  ) : (
    <>
      <div className={classes.newcardcredential}>
        <Typography key="message">No Door Controls Available</Typography>
      </div>
    </>
  );

  return (
    <>
      <Typography variant="h5">Door Control</Typography>
      <br />
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        <Link color="inherit" href="/dashboard">
          Dashboard
        </Link>
        <Typography color="textPrimary">Door Control</Typography>
      </Breadcrumbs>
      <br />
      <div className={classes.content}>{renderedDoorControls}</div>
    </>
  );
};

export default DoorControlView;
